import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2ecb42c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25 letter-spacing d-flex flex-column survey-card" }
const _hoisted_2 = { class: "mb-10 d-flex justify-content-between" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["data-bs-target"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-fat-line-up text-warning lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-fat-line-up text-success" }, null, -1 /* HOISTED */))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "survey-detail"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyView = _resolveComponent("SurveyView")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card border-0 rounded-0 bg-white todays-course-box", { 'detail-visible': _ctx.survey_detail !== undefined }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.survey.title), 1 /* TEXT */)
          ])
        ]),
        (_ctx.env !== 'kareena')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.survey.description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex align-items-center gap-3", _ctx.survey.has_override_settings || !_ctx.survey.has_override_settings ? 'justify-content-between' : ''])
        }, [
          (_ctx.env == 'kareena' && _ctx.survey.extra?.group === 'sintomi' && _ctx.survey.priority_enabled !== false && _ctx.update_enabled)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.survey.has_override_settings)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
                      "data-bs-toggle": "modal",
                      "data-bs-target": '#confirmModal' + _ctx.survey.id
                    }, [
                      _hoisted_7,
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("feature.surveys.set_priority")), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [..._hoisted_11]))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (_ctx.survey_detail === undefined)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                class: "ms-auto card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block"
              }, _toDisplayString(_ctx.$t("cta.view")), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn-close ms-auto",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.survey_detail = undefined))
              }))
        ], 2 /* CLASS */)
      ]),
      (_ctx.survey_detail !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_SurveyView, {
              survey: _ctx.survey_detail,
              patient_id: _ctx.patient.id!,
              show_description: false
            }, null, 8 /* PROPS */, ["survey", "patient_id"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (_openBlock(), _createBlock(_component_ConfirmModal, {
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSurveyPriority(_ctx.survey.id, true))),
      key: _ctx.survey.id,
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('feature.surveys.modal_message'),
      id: 'confirmModal' + _ctx.survey.id
    }, null, 8 /* PROPS */, ["title", "message", "id"]))
  ], 64 /* STABLE_FRAGMENT */))
}